import React from 'react';
import {Carousel, Col, Container, Row, Image} from "react-bootstrap";
import picture from './assets/home.jpg';
import { ReactComponent as MemberIcon } from './assets/icons/card_membership.svg';
import { ReactComponent as ExploreIcon } from './assets/icons/explore.svg';
import { ReactComponent as VerifiedIcon } from './assets/icons/verified.svg';
import './css/app.css';
import {Footer} from "./components/Footer";
import {Header} from "./components/Header";

function App() {
  return (
      <Container fluid>
        <Header />

        <Row>
          <Carousel controls={false} indicators={false}>
            <Carousel.Item>
              <img className="d-block w-100" src={picture} alt="First slide" />

              <Carousel.Caption>
                <p>Vous désirez vendre vos véhicules ? </p>

                <a className="myContactButton txtStd" href={'/contact'}>
                  Contactez-nous
                </a>
              </Carousel.Caption>

            </Carousel.Item>
          </Carousel>
        </Row>

        <Row className="myTextArea">
          <Col lg={4} md={12} xs={12}>
            <Row className="justify-content-center myIcon">
              <MemberIcon width={72} height={72} fill={'#DB222A'} />
            </Row>

            <p className="text-justify">
              Une transaction c'est un acte de confiance. Nous mettons un point d'honneur à établir cette confiance dès le premier contact.
            </p>
          </Col>

          <Col lg={4} md={12} xs={12}>
            <Row className="justify-content-center myIcon">
              <ExploreIcon width={72} height={72} fill={'#DB222A'} />
            </Row>

            <p className="text-justify">
              Nous nous déplaçons dans toute la Belgique. Nos expertises sont réalisées en toute transparence par nos professionnels.
            </p>
          </Col>

          <Col lg={4} md={12} xs={12}>
            <Row className="justify-content-center myIcon">
              <VerifiedIcon width={72} height={72} fill={'#DB222A'} />
            </Row>

            <p className="text-justify">
              Nous achetons cash tout type de véhicule, peu importe la marque, l’âge, l’état, accidentée, ou sans contrôle technique.
            </p>
          </Col>
        </Row>

        <Col lg={12}>
          <p className="text-center">
            <a href="/contact">Contactez-nous </a>
            pour une expertise de vos véhicules <strong>sans frais</strong> et <strong>sans engagement</strong>.
          </p>
        </Col>

        <Row className="justify-content-between myfeedbackArea">
          <Col xs={12}>
            <h2>5 étoiles sur Google Maps ! </h2>
          </Col>

          <Col className={'justify-content-bottom'} lg={3}>
            <Row className="justify-content-center myfeedbackIcon">
              <p className="blockquote myfeedbackComment">
                "Top service! J’ai acheté déjà 2 voitures et jamais de problèmes. Patron est aussi très sympathique!"
              </p>
            </Row>

            <Row>
              <p className="blockquote-footer">Lorenzo Dal Bo'</p>
            </Row>

          </Col>

          <Col className={'justify-content-bottom'} lg={3}>

            <Row className="justify-content-center myfeedbackIcon">
              <p className="blockquote myfeedbackComment">"Professionnalisme et sérieux sont au rendez-vous ! Je le conseil fortement."</p>
            </Row>

            <Row>
              <p className="blockquote-footer">Seba</p>
            </Row>

          </Col>

          <Col className={'justify-content-bottom'} lg={3}>

            <Row className="justify-content-center myfeedbackIcon">
              <p className="blockquote myfeedbackComment">
                "Un service au « Top » et professionnel depuis de nombreuses années. Grand choix d’utilitaires ! Je recommande vivement
                👌🏽👌🏽"
              </p>
            </Row>

            <Row>
              <p className="blockquote-footer">Zina Papanikolaou</p>
            </Row>
          </Col>
        </Row>

        <Row className="myTextArea">
          <p className="text-justify">
            Nous sommes spécialisés dans l'achat et la vente de véhicules de toute marque (camionettes, camions, citadines), neufs ou
            accidentés (même avec moteur cassé). Nous payons aussi bien en cash que par virement bancaire.
            <br />
            Chez <strong>PLP MOTORS</strong>, nous mettons l'accent sur la confiance et la qualité de nos services. C'est la raison pour
            laquelle nous avons acquis, avec nos 25 années d'expérience, une clientèle fidèle.
          </p>
        </Row>

        <Row className="justify-content-center">
          <h2>Nos partenaires</h2>
        </Row>

        <Row className={'justify-content-center myPartners'}>
            <Col style={{ margin: 12 }} className={'justify-content-center'} xs={12} md={3}>
                <a href={'https://www.williams-chassis.be/'}>
                  <Image fluid src="/images/chassisWilliams.jpg" />
                </a>
            </Col>

            <Col style={{ margin: 12 }} className={'justify-content-center'} xs={12} md={3}>
                <a href={'http://www.detroyer.be/'}>
                  <Image fluid src="/images/detroyer.jpg" />
                </a>
            </Col>

            <Col style={{ margin: 12 }} className={'justify-content-center'} xs={12} md={3}>
                <a href={'https://www.1717.be/'}>
                  <Image fluid src="/images/AUTOS-INDUSTRIES-Christiaens.png" />
                </a>
            </Col>

            <Col style={{ margin: 12 }} className={'justify-content-center'} xs={12} md={3}>
                <a href={'https://sirre.be/'}>
                  <Image style={{maxHeight: '6em'}} fluid src="/images/sirre.jpeg" />
                </a>
            </Col>

            <Col style={{ margin: 12 }} className={'justify-content-center'} xs={12} md={3}>
                <a href={'https://goodmeat.be/'}>
                  <Image fluid src="/images/goodmeat.jpg" />
                </a>
            </Col>
        </Row>

      <Footer />

      </Container>
  );
}

export default App;